import { connect } from "react-redux";

import Row from "../components/Table.Row.Component";

import * as tableActions from "../commands/table.actions";

function mapStateToProps(state) {
  return {
    tables: state.tables,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectRowFunc: (key, isSelected, tableKey) => {
      dispatch(tableActions.select_item(key, isSelected, tableKey));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Row);
